"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  key: 'inputMask',
  ignore: true
}, {
  key: 'allowMultipleMasks',
  ignore: true
}, {
  key: 'showWordCount',
  ignore: true
}, {
  key: 'showCharCount',
  ignore: true
}];
exports.default = _default;